<ng-container *ngIf="isLoading; else tableTpl">
  <div class="p-4 text-sm opacity-70">Loading…</div>
</ng-container>

<ng-template #tableTpl>
  <table class="w-full border-collapse" style="width:100%; border-collapse:collapse;">
    <thead>
      <tr>
        <th *ngFor="let h of table?.headers"
            class="border-b py-2 pr-2"
            [ngStyle]="h === 'Date'
              ? { width: '110px', minWidth: '110px', maxWidth: '110px', whiteSpace: 'nowrap',
                  textAlign: 'left', fontVariantNumeric: 'tabular-nums' }
              : { textAlign: 'right', fontVariantNumeric: 'tabular-nums' }">
          {{ h }}
        </th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let r of table?.records">
        <td *ngFor="let h of table?.headers"
            class="border-b py-1 pr-2"
            [ngStyle]="h === 'Date'
              ? { width: '110px', minWidth: '110px', maxWidth: '110px', whiteSpace: 'nowrap',
                  textAlign: 'left', fontVariantNumeric: 'tabular-nums' }
              : { textAlign: 'right', fontVariantNumeric: 'tabular-nums' }">
          {{ r[h === 'Date' ? 'date' : h] }}
        </td>
      </tr>

      <tr *ngIf="table && table.headers.length > 1" class="font-semibold">
        <td
          [ngStyle]="{ width: '120px', minWidth: '120px', maxWidth: '120px',
                       whiteSpace: 'nowrap', textAlign: 'left', fontVariantNumeric: 'tabular-nums' }">
          Totals
        </td>
        <td *ngFor="let h of table.headers.slice(1)"
            [ngStyle]="{ textAlign: 'right', fontVariantNumeric: 'tabular-nums' }">
          {{ table.totals[h] ?? '' }}
        </td>
      </tr>
    </tbody>
  </table>
</ng-template>
